import { Injectable, EventEmitter } from '@angular/core';

import {
	SignalRService,
	SignalREventService,
	ToastrService,
	MinesiteService,
	EquipmentService,
	DocumentService,
	UserCompany,
	GlobalService,
	LoggingService
} from './../index';

@Injectable()
export class AssociationService {

	public documentsAssociated: EventEmitter<boolean> = new EventEmitter<boolean>();
	public userCompaniesChanged: EventEmitter<UserCompany[]> = new EventEmitter<UserCompany[]>();

	constructor(
		private _signalRService: SignalRService,
		private _signalREventService: SignalREventService,
		private _minesiteService: MinesiteService,
		private _equipmentService: EquipmentService,
		private _toastrService: ToastrService,
		private _documentService: DocumentService,
		private _GlobalService: GlobalService,
		private _loggingService: LoggingService
	) {
		this.registerOnServerEvents();
	}

	public associateMinesiteToCompany(companyId: number, minesiteId: number, Live: boolean): void {
		this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
			if (result != null) {
				if (result.IsNew) {
					this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
					this._GlobalService.TriggerLockEnvironment('1');
					this._signalRService.invoke('AssociateMinesiteToCompnay', companyId, minesiteId, Live, Number(localStorage.getItem('User_ID')));
				} else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
					this._signalRService.invoke('AssociateMinesiteToCompnay', companyId, minesiteId, Live, Number(localStorage.getItem('User_ID')));
				} else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
					this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
					this._GlobalService.TriggerLockEnvironment('1');
				}
			}
		});
	}

	public associateEquipmentToMinesite(minesiteId: number, equipmentId: number): void {
		this._loggingService.log(`associationService.associateEquipmentToMinesite: minesiteId: ${minesiteId}, equipmentId: ${equipmentId}`);
		this._signalRService.invoke('LockStagingTab', Number(localStorage.getItem('User_ID'))).then((result: any) => {
			if (result != null) {
				if (result.IsNew) {
					this._loggingService.log(`associationService.associateEquipmentToMinesite: IsNew - invoke AssociateEquipmentToMinesite: minesiteId: ${minesiteId}, equipmentId: ${equipmentId}, userId: ${Number(localStorage.getItem('User_ID'))}`);
					this._toastrService.displayToastrMessage('success', 'Staging environment is locked successfully', 'Staging environment Status!');
					this._GlobalService.TriggerLockEnvironment('1');
					this._signalRService.invoke('AssociateEquipmentToMinesite', minesiteId, equipmentId, Number(localStorage.getItem('User_ID')));
				} else if (result.IsLocked && result.LockedBy == Number(localStorage.getItem('User_ID'))) {
					this._loggingService.log(`associationService.associateEquipmentToMinesite: IsLocked - invoke AssociateEquipmentToMinesite: minesiteId: ${minesiteId}, equipmentId: ${equipmentId}, userId: ${Number(localStorage.getItem('User_ID'))}`);
					this._signalRService.invoke('AssociateEquipmentToMinesite', minesiteId, equipmentId, Number(localStorage.getItem('User_ID')));
				} else if (result.IsLocked && result.LockedBy != Number(localStorage.getItem('User_ID'))) {
					this._loggingService.warn(`associationService.associateEquipmentToMinesite: IsLocked - By another user: ${result.Note}`);
					this._toastrService.displayToastrMessage('error', result.Note, 'Staging environment Status!');
					this._GlobalService.TriggerLockEnvironment('1');
				}
			}
		});
	}

	public associateDocumentsToEquipment(equipmentId: number, documentIds: number[]): void {
		this._signalRService.invoke('AssociateDocumentsToEquipment', equipmentId, documentIds);
	}
	public getUserCompaniesList(userId: number): void {
		this._signalRService.invoke('GetUserCompaniesList', userId);
	}

	public associateUserToCompanies(userId: number, companyIds: number[]): void {
		this._signalRService.invoke('AssociateUserToCompanies', userId, companyIds);
	}
	public removeUserCompanyAssociation(userId: number, companyIds: number[]): void {
		this._signalRService.invoke('RemoveAssociatedCompaniesFromUser', userId, companyIds);
	}

	public removeDocumentAssociations(equipmentId: number, documentIds: number[]): void {
		this._signalRService.invoke('RemoveAssociatedDocuments', equipmentId, documentIds);
	}

	private onMinesiteAssociated(info: any): void {
		this._minesiteService.getMinesitesForCompanyStaging(info.Data.Company.Id);
	}

	private onEquipmentAssociated(info: any): void {
		this._loggingService.log(`associationService.onEquipmentAssociated: minesiteId: ${info?.Data?.Minesite?.Minesite_ID}`);
		this._equipmentService.getEquipmentForMinesiteStaging(info.Data.Minesite.Minesite_ID);
	}
	private onDocumentsAssociated(info: any): void {
		if (info.Data.Documents.length > 1) {
			this._toastrService.displayToastrMessage('success', info.Data.Documents.length + ' documents associated to ' + info.Data.Equipment.Serial + '!', 'Documents Associated');
		} else if (info.Data.Documents.length > 0) {
			this._toastrService.displayToastrMessage('success', info.Data.Documents[0].FileName + ' associated to ' + info.Data.Equipment.Serial + '!', 'Document Associated');
		}
		this._documentService.getEquipmentDocuments(info.Data.Equipment.Id);
		this.documentsAssociated.emit(true);
	}

	private onDocumentsRemoved(info: any): void {
		if (info.Data.Documents.length > 1) {
			this._toastrService.displayToastrMessage('success', info.Data.Documents.length + ' documents unnasociated to ' + info.Data.Equipment.Serial + '!', 'Documents Removed');
		} else {
			this._toastrService.displayToastrMessage('success', info.Data.Documents[0].FileName + ' unnasociated to ' + info.Data.Equipment.Serial + '!', 'Document Removed');
		}
		this._documentService.getEquipmentDocuments(info.Data.Equipment.Id);
		this.documentsAssociated.emit(true);
	}

	private onUserCompaniesChanged(info: any): void {
		this._toastrService.displayToastrMessage('success', info.Data.UserCompanies.length + ' Companies associated to user ' + info.Data.Name + '!', 'Companies ' + info.Data.State);
		this.userCompaniesChanged.emit(info.Data.UserCompanies);
	}

	private registerOnServerEvents() {
		this._signalREventService.registerAdvanced(this, 'minesiteAssociated', (info: any) => this.onMinesiteAssociated(info));
		this._signalREventService.registerAdvanced(this, 'equipmentAssociated', (info: any) => this.onEquipmentAssociated(info));
		this._signalREventService.registerAdvanced(this, 'documentAssociated', (info: any) => this.onDocumentsAssociated(info));
		this._signalREventService.registerAdvanced(this, 'documentsRemoved', (info: any) => this.onDocumentsRemoved(info));
		this._signalREventService.registerAdvanced(this, 'userCompanyChange', (info: any) => this.onUserCompaniesChanged(info));
	}


	public deregisterOnServerEvents(): void {
		this._signalREventService.deregister('AssociationService');
	}
}
